var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0044153,20.5707805 C13.8667747,22.7303906 11.8752294,24.0608281 9.53834488,24.2218013 C9.18738502,24.2454199 8.81911325,24.2454199 8.46815339,24.2218013 C6.13126889,24.0608281 4.13972348,22.7333717 3.00208296,20.5707805 C1.82060057,18.3189889 1.84982849,15.6523817 3.07807555,13.4480567 L9.00617192,2.88000001 L14.9284228,13.4480567 C16.1625154,15.6461904 16.1946661,18.310046 15.0044153,20.5707805 Z M10.1869979,0.702878956 C9.94148677,0.26308411 9.49066517,0 8.9996429,0 C8.50882574,0 8.05779902,0.26308411 7.812493,0.702878956 L1.22799521,12.4294201 C-0.37018586,15.2705617 -0.410181408,18.7035902 1.11846894,21.5991845 C2.58579277,24.3862904 5.2778008,26.1692537 8.33038406,26.3783023 C8.54923151,26.3918634 8.77587294,26.4 9.00005311,26.4 C9.22423328,26.4 9.45087473,26.3918634 9.66951706,26.3783023 C12.7163574,26.1692537 15.4139033,24.3835782 16.8814322,21.5991845 C18.4100825,18.6954536 18.370292,15.2705617 16.772111,12.4294201 L10.1869979,0.702878956 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrop);
export default __webpack_public_path__ + "static/media/icon-drop.8d99f8093eaff5462ee7ab14f5246172.svg";
export { ForwardRef as ReactComponent };